// import React, { useState, useEffect } from 'react';
// import { ref, get } from 'firebase/database';
// import { database } from '../firebase';
// import Header from './Header';
// import { toast } from 'react-toastify';
// import styled from 'styled-components';

// const Container = styled.div`
//   padding: 3rem;
//   max-width: 1100px;
//   margin: 2rem auto;
//   background: #ffffff;
//   border-radius: 20px;
//   box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//   position: relative;
//   overflow: hidden;
//   font-family: 'Poppins', sans-serif;

//   &:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     height: 6px;
//     background: linear-gradient(90deg, #3b82f6, #10b981);
//   }

//   @media (max-width: 768px) {
//     padding: 1.5rem;
//     margin: 1rem;
//   }
// `;

// const Title = styled.h1`
//   font-size: 2.5rem;
//   font-weight: 700;
//   color: #1e3a8a;
//   text-align: center;
//   margin-bottom: 2.5rem;
//   position: relative;
//   animation: slideIn 0.5s ease-out;

//   &:after {
//     content: '';
//     width: 80px;
//     height: 5px;
//     background: linear-gradient(90deg, #3b82f6, #10b981);
//     position: absolute;
//     bottom: -10px;
//     left: 50%;
//     transform: translateX(-50%);
//     border-radius: 3px;
//   }

//   @keyframes slideIn {
//     from {
//       transform: translateY(-20px);
//       opacity: 0;
//     }
//     to {
//       transform: translateY(0);
//       opacity: 1;
//     }
//   }
// `;

// const LoadingContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   gap: 1.5rem;
//   padding: 3rem;
// `;

// const Spinner = styled.div`
//   width: 60px;
//   height: 60px;
//   border: 6px solid rgba(59, 130, 246, 0.2);
//   border-top-color: #3b82f6;
//   border-right-color: #10b981;
//   border-radius: 50%;
//   animation: spin 1s ease-in-out infinite;

//   @keyframes spin {
//     to {
//       transform: rotate(360deg);
//     }
//   }
// `;

// const Table = styled.table`
//   width: 100%;
//   border-collapse: separate;
//   border-spacing: 0;
//   background: white;
//   border-radius: 12px;
//   overflow: hidden;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

//   @media (max-width: 768px) {
//     display: none;
//   }
// `;

// const MobileCardContainer = styled.div`
//   display: none;
//   @media (max-width: 768px) {
//     display: flex;
//     flex-direction: column;
//     gap: 1rem;
//   }
// `;

// const MobileCard = styled.div`
//   background: white;
//   border-radius: 12px;
//   padding: 1rem;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
//   transition: transform 0.3s ease, box-shadow 0.3s ease;

//   &:hover {
//     transform: translateY(-5px);
//     box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
//   }
// `;

// const MobileCardContent = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// `;

// const Th = styled.th`
//   padding: 1.2rem;
//   text-align: left;
//   color: #1e293b;
//   font-weight: 600;
//   font-size: 1rem;
//   background: linear-gradient(180deg, #f8fafc, #f1f5f9);
//   border-bottom: 2px solid #e5e7eb;

//   &:first-child {
//     border-top-left-radius: 12px;
//   }
//   &:last-child {
//     border-top-right-radius: 12px;
//   }
// `;

// const Tr = styled.tr`
//   transition: all 0.3s ease;
//   opacity: 0;
//   animation: fadeIn 0.5s ease forwards;
//   animation-delay: ${props => props.index * 0.1}s;

//   &:hover {
//     background: ${props => props.clickable ? '#eff6ff' : 'white'};
//     transform: scale(1.01);
//   }

//   @keyframes fadeIn {
//     to {
//       opacity: 1;
//     }
//   }
// `;

// const Td = styled.td`
//   padding: 1.2rem;
//   border-bottom: 1px solid #f1f5f9;
//   font-size: 0.95rem;
//   color: #334155;

//   @media (max-width: 768px) {
//     padding: 0.8rem;
//     font-size: 0.9rem;
//   }
// `;

// const DownloadButton = styled.span`
//   color: white;
//   background: linear-gradient(90deg, #3b82f6, #2563eb);
//   font-weight: 500;
//   cursor: pointer;
//   padding: 0.6rem 1.2rem;
//   border-radius: 8px;
//   transition: all 0.3s ease;
//   display: inline-block;
//   position: relative;
//   overflow: hidden;

//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
//   }

//   &:after {
//     content: '';
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     width: 0;
//     height: 0;
//     background: rgba(255, 255, 255, 0.3);
//     border-radius: 50%;
//     transform: translate(-50%, -50%);
//     transition: width 0.4s ease, height 0.4s ease;
//   }

//   &:active:after {
//     width: 200px;
//     height: 200px;
//   }
// `;

// const NotUploaded = styled.span`
//   color: #9ca3af;
//   font-style: italic;
//   padding: 0.6rem 1.2rem;
// `;

// const SkeletonRow = styled.tr`
//   animation: shimmer 2s infinite linear;
//   background: linear-gradient(90deg, #f8fafc 25%, #e5e7eb 50%, #f8fafc 75%);

//   @keyframes shimmer {
//     0% {
//       background-position: -200px 0;
//     }
//     100% {
//       background-position: 200px 0;
//     }
//   }
// `;

// const SkeletonCard = styled.div`
//   background: linear-gradient(90deg, #f8fafc 25%, #e5e7eb 50%, #f8fafc 75%);
//   border-radius: 12px;
//   padding: 1rem;
//   height: 80px;
//   animation: shimmer 2s infinite linear;

//   @keyframes shimmer {
//     0% {
//       background-position: -200px 0;
//     }
//     100% {
//       background-position: 200px 0;
//     }
//   }
// `;

// const CBSEDisclosures = () => {
//   const [documents, setDocuments] = useState([
//     { sNo: 1, name: 'TRUST REGISTRATION', pdfUrl: null },
//     { sNo: 2, name: 'NOC', pdfUrl: null },
//     { sNo: 3, name: 'RECOGNITION CERTIFICATE', pdfUrl: null },
//     { sNo: 4, name: 'BUILDING SAFETY CERTIFICATE', pdfUrl: null },
//     { sNo: 5, name: 'FIRE SAFETY CERTIFICATE', pdfUrl: null },
//     { sNo: 6, name: 'WATER HEALTH & SANITARY CERTIFICATE', pdfUrl: null },
//     { sNo: 7, name: 'FEE STRUCTURE OF THE SCHOOL', pdfUrl: null },
//     { sNo: 8, name: 'ANNUAL ACADEMIC CALENDAR', pdfUrl: null },
//     { sNo: 9, name: 'SMC', pdfUrl: null },
//     { sNo: 10, name: 'PTA', pdfUrl: null },
//     { sNo: 11, name: 'RTE', pdfUrl: null },
//     { sNo: 12, name: 'TEACHING STAFF', pdfUrl: null },
//     { sNo: 13, name: 'CERTIFICATE OF LAND', pdfUrl: null },
//     { sNo: 14, name: 'SELF CERTIFICATE', pdfUrl: null },
//     { sNo: 15, name: 'LIBRARY', pdfUrl: null },
//     { sNo: 16, name: 'SCHOOL COMPOUND', pdfUrl: null },
//     { sNo: 17, name: 'CSWN – BOYS & GIRLS', pdfUrl: null },
//     { sNo: 18, name: 'SCIENCE LAB', pdfUrl: null },
//     { sNo: 19, name: 'SCHOOL ENTRY VIEW & CLASS ROOMS', pdfUrl: null },
//     { sNo: 20, name: 'COMPUTER LAB', pdfUrl: null },
//   ]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchDocuments = async () => {
//       try {
//         const docsRef = ref(database, 'school/documents');
//         const snapshot = await get(docsRef);
        
//         if (snapshot.exists()) {
//           const storedDocs = snapshot.val();
//           setDocuments((prevDocs) =>
//             prevDocs.map((doc) => ({
//               ...doc,
//               pdfUrl: storedDocs[doc.sNo]?.pdfUrl || null,
//             }))
//           );
//           toast.success('Documents loaded successfully', {
//             position: "top-center",
//             autoClose: 2000,
//           });
//         } else {
//           toast.info('No documents available at the moment', {
//             position: "top-center",
//             autoClose: 3000,
//           });
//         }
//       } catch (error) {
//         console.error('Error fetching documents:', error);
//         toast.error('Failed to load documents. Please try again.', {
//           position: "top-center",
//           autoClose: 3000,
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDocuments();
//   }, []);

//   const handleDocumentClick = (pdfUrl, docName) => {
//     if (pdfUrl) {
//       const link = document.createElement('a');
//       link.href = pdfUrl;
//       link.download = `${docName.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       toast.success(`Downloading ${docName}`, {
//         position: "top-center",
//         autoClose: 2000,
//       });
//     } else {
//       toast.info('This document is not available yet', {
//         position: "top-center",
//         autoClose: 3000,
//       });
//     }
//   };

//   const renderSkeletonRows = () => {
//     return Array(5).fill().map((_, index) => (
//       <SkeletonRow key={index}>
//         <Td><div style={{ height: '24px', background: '#e5e7eb', borderRadius: '6px' }}></div></Td>
//         <Td><div style={{ height: '24px', background: '#e5e7eb', borderRadius: '6px' }}></div></Td>
//         <Td><div style={{ height: '24px', background: '#e5e7eb', borderRadius: '6px' }}></div></Td>
//       </SkeletonRow>
//     ));
//   };

//   const renderSkeletonCards = () => {
//     return Array(5).fill().map((_, index) => (
//       <SkeletonCard key={index} />
//     ));
//   };

//   return (
//     <>
//     <Header/>
//     <Container>
//       <Title>CBSE Mandatory Disclosures</Title>
//       {loading ? (
//         <LoadingContainer>
//           <Spinner />
//           <p>Loading documents...</p>
//         </LoadingContainer>
//       ) : (
//         <>
//           <Table>
//             <thead>
//               <tr>
//                 <Th>S.No</Th>
//                 <Th>Document/Information</Th>
//                 <Th>Action</Th>
//               </tr>
//             </thead>
//             <tbody>
//               {documents.map((doc, index) => (
//                 <Tr
//                   key={doc.sNo}
//                   clickable={!!doc.pdfUrl}
//                   index={index}
//                   onClick={() => handleDocumentClick(doc.pdfUrl, doc.name)}
//                 >
//                   <Td>{doc.sNo}</Td>
//                   <Td>{doc.name}</Td>
//                   <Td>
//                     {doc.pdfUrl ? (
//                       <DownloadButton>Download PDF</DownloadButton>
//                     ) : (
//                       <NotUploaded>Not Uploaded</NotUploaded>
//                     )}
//                   </Td>
//                 </Tr>
//               ))}
//             </tbody>
//           </Table>
//           <MobileCardContainer>
//             {documents.map((doc) => (
//               <MobileCard
//                 key={doc.sNo}
//                 onClick={() => handleDocumentClick(doc.pdfUrl, doc.name)}
//               >
//                 <MobileCardContent>
//                   <div>
//                     <strong>{doc.sNo}.</strong> {doc.name}
//                   </div>
//                   {doc.pdfUrl ? (
//                     <DownloadButton>Download</DownloadButton>
//                   ) : (
//                     <NotUploaded>Not Uploaded</NotUploaded>
//                   )}
//                 </MobileCardContent>
//               </MobileCard>
//             ))}
//           </MobileCardContainer>
//         </>
//       )}
//     </Container>
//     </>
//   );
// };

// export default CBSEDisclosures;







import React, { useState, useEffect } from 'react';
import { ref, get } from 'firebase/database';
import { database } from '../firebase';
import Header from './Header';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import Footer from './Footer';

const Container = styled.div`
  padding: 3rem;
  max-width: 1100px;
  margin: 2rem auto;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  font-family: 'Poppins', sans-serif;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 6px;
    background: linear-gradient(90deg, #3b82f6, #10b981);
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
    margin: 1rem;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #1e3a8a;
  text-align: center;
  margin-bottom: 2.5rem;
  position: relative;
  animation: slideIn 0.5s ease-out;

  &:after {
    content: '';
    width: 80px;
    height: 5px;
    background: linear-gradient(90deg, #3b82f6, #10b981);
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 3px;
  }

  @keyframes slideIn {
    from {
      transform: translateY(-20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 3rem;
`;

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 6px solid rgba(59, 130, 246, 0.2);
  border-top-color: #3b82f6;
  border-right-color: #10b981;
  border-radius: 50%;
  animation: spin 1s ease-in-out infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileCardContainer = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;

const MobileCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
`;

const MobileCardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Th = styled.th`
  padding: 1.2rem;
  text-align: left;
  color: #1e293b;
  font-weight: 600;
  font-size: 1rem;
  background: linear-gradient(180deg, #f8fafc, #f1f5f9);
  border-bottom: 2px solid #e5e7eb;

  &:first-child {
    border-top-left-radius: 12px;
  }
  &:last-child {
    border-top-right-radius: 12px;
  }
`;

const Tr = styled.tr`
  transition: all 0.3s ease;
  opacity: 0;
  animation: fadeIn 0.5s ease forwards;
  animation-delay: ${props => props.$index * 0.1}s;

  &:hover {
    background: ${props => props.$clickable ? '#eff6ff' : 'white'};
    transform: scale(1.01);
  }

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
`;

const Td = styled.td`
  padding: 1.2rem;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.95rem;
  color: #334155;

  @media (max-width: 768px) {
    padding: 0.8rem;
    font-size: 0.9rem;
  }
`;

const DownloadButton = styled.span`
  color: white;
  background: linear-gradient(90deg, #3b82f6, #2563eb);
  font-weight: 500;
  cursor: pointer;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: inline-block;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  }

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: width 0.4s ease, height 0.4s ease;
  }

  &:active:after {
    width: 200px;
    height: 200px;
  }
`;

const VideoButton = styled.span`
  color: white;
  background: linear-gradient(90deg, #ef4444, #dc2626);
  font-weight: 500;
  cursor: pointer;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: inline-block;
  margin-left: 0.5rem;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
  }

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: width 0.4s ease, height 0.4s ease;
  }

  &:active:after {
    width: 200px;
    height: 200px;
  }
`;

const NotUploaded = styled.span`
  color: #9ca3af;
  font-style: italic;
  padding: 0.6rem 1.2rem;
`;

const VideoContainer = styled.div`
  margin-top: 1rem;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const SkeletonRow = styled.tr`
  animation: shimmer 2s infinite linear;
  background: linear-gradient(90deg, #f8fafc 25%, #e5e7eb 50%, #f8fafc 75%);

  @keyframes shimmer {
    0% {
      background-position: -200px 0;
    }
    100% {
      background-position: 200px 0;
    }
  }
`;

const SkeletonCard = styled.div`
  background: linear-gradient(90deg, #f8fafc 25%, #e5e7eb 50%, #f8fafc 75%);
  border-radius: 12px;
  padding: 1rem;
  height: 80px;
  animation: shimmer 2s infinite linear;

  @keyframes shimmer {
    0% {
      background-position: -200px 0;
    }
    100% {
      background-position: 200px 0;
    }
  }
`;

const extractYoutubeId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url?.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
};

const CBSEDisclosures = () => {
  const [documents, setDocuments] = useState([
    { sNo: 1, name: 'TRUST REGISTRATION', pdfUrl: null, youtubeUrl: null },
    { sNo: 2, name: 'NOC', pdfUrl: null, youtubeUrl: null },
    { sNo: 3, name: 'RECOGNITION CERTIFICATE', pdfUrl: null, youtubeUrl: null },
    { sNo: 4, name: 'BUILDING SAFETY CERTIFICATE', pdfUrl: null, youtubeUrl: null },
    { sNo: 5, name: 'FIRE SAFETY CERTIFICATE', pdfUrl: null, youtubeUrl: null },
    { sNo: 6, name: 'WATER HEALTH & SANITARY CERTIFICATE', pdfUrl: null, youtubeUrl: null },
    { sNo: 7, name: 'FEE STRUCTURE OF THE SCHOOL', pdfUrl: null, youtubeUrl: null },
    { sNo: 8, name: 'ANNUAL ACADEMIC CALENDAR', pdfUrl: null, youtubeUrl: null },
    { sNo: 9, name: 'SMC', pdfUrl: null, youtubeUrl: null },
    { sNo: 10, name: 'PTA', pdfUrl: null, youtubeUrl: null },
    { sNo: 11, name: 'INFRASTRUCTURE DETAILS', pdfUrl: null, youtubeUrl: null },
    { sNo: 12, name: 'TEACHING STAFF', pdfUrl: null, youtubeUrl: null },
    { sNo: 13, name: 'CERTIFICATE OF LAND', pdfUrl: null, youtubeUrl: null },
    { sNo: 14, name: 'SELF CERTIFICATE', pdfUrl: null, youtubeUrl: null },
  ]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const docsRef = ref(database, 'school/documents');
        const snapshot = await get(docsRef);
        
        if (snapshot.exists()) {
          const storedDocs = snapshot.val();
          setDocuments((prevDocs) =>
            prevDocs.map((doc) => {
              const storedDoc = storedDocs[doc.sNo] || {};
              return {
                ...doc,
                pdfUrl: storedDoc.pdfUrl || null,
                youtubeUrl: storedDoc.youtubeUrl || null,
                pdfApplicable: storedDoc.pdfApplicable !== undefined ? storedDoc.pdfApplicable : true,
                youtubeApplicable: storedDoc.youtubeApplicable !== undefined ? storedDoc.youtubeApplicable : (doc.sNo >= 15),
              };
            })
          );
          toast.success('Documents loaded successfully', {
            position: "top-center",
            autoClose: 2000,
          });
        } else {
          toast.info('No documents available at the moment', {
            position: "top-center",
            autoClose: 3000,
          });
        }
      } catch (error) {
        console.error('Error fetching documents:', error);
        toast.error('Failed to load documents. Please try again.', {
          position: "top-center",
          autoClose: 3000,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, []);

  // Helper function to remove token from Firebase Storage URLs
  const stripToken = (url) => {
    if (!url) return url;
    try {
      const urlObj = new URL(url);
      urlObj.searchParams.delete('token');
      return urlObj.toString();
    } catch {
      // If URL parsing fails, try simple string replacement
      return url.replace(/&token=[^&]+/, '').replace(/\?token=[^&]+&?/, '?');
    }
  };

  const handleDocumentClick = (pdfUrl, docName) => {
    if (pdfUrl) {
      const cleanUrl = stripToken(pdfUrl);
      const link = document.createElement('a');
      link.href = cleanUrl;
      link.download = `${docName.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success(`Downloading ${docName}`, {
        position: "top-center",
        autoClose: 2000,
      });
    } else {
      toast.info('This document is not available yet', {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  const handleVideoClick = (youtubeUrl, docName) => {
    if (youtubeUrl) {
      window.open(youtubeUrl, '_blank');
      toast.success(`Opening ${docName} video`, {
        position: "top-center",
        autoClose: 2000,
      });
    } else {
      toast.info('Video not available for this document', {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  const renderSkeletonRows = () => {
    return Array(5).fill().map((_, index) => (
      <SkeletonRow key={index}>
        <Td><div style={{ height: '24px', background: '#e5e7eb', borderRadius: '6px' }}></div></Td>
        <Td><div style={{ height: '24px', background: '#e5e7eb', borderRadius: '6px' }}></div></Td>
        <Td><div style={{ height: '24px', background: '#e5e7eb', borderRadius: '6px' }}></div></Td>
      </SkeletonRow>
    ));
  };

  const renderSkeletonCards = () => {
    return Array(5).fill().map((_, index) => (
      <SkeletonCard key={index} />
    ));
  };

  return (
    <>
      <Header />
      <Container>
        <Title>CBSE Mandatory Disclosures</Title>
        {loading ? (
          <LoadingContainer>
            <Spinner />
            <p>Loading documents...</p>
          </LoadingContainer>
        ) : (
          <>
            <Table>
              <thead>
                <tr>
                  <Th>S.No</Th>
                  <Th>Document/Information</Th>
                  <Th>Action</Th>
                </tr>
              </thead>
              <tbody>
                {documents.map((doc, index) => (
                  <React.Fragment key={doc.sNo}>
                    <Tr
                      $clickable={!!doc.pdfUrl}
                      $index={index}
                    >
                      <Td>{doc.sNo}</Td>
                      <Td>{doc.name}</Td>
                      <Td>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <div>
                            {doc.pdfApplicable !== false && (
                              doc.pdfUrl ? (
                                <DownloadButton onClick={() => handleDocumentClick(doc.pdfUrl, doc.name)}>
                                  Download PDF
                                </DownloadButton>
                              ) : (
                                <NotUploaded>PDF Not Uploaded</NotUploaded>
                              )
                            )}
                            {doc.youtubeApplicable !== false && (
                              doc.youtubeUrl ? (
                                <VideoButton onClick={() => handleVideoClick(doc.youtubeUrl, doc.name)}>
                                  Watch Video
                                </VideoButton>
                              ) : (
                                <NotUploaded>Video Not Available</NotUploaded>
                              )
                            )}
                          </div>
                        </div>
                      </Td>
                    </Tr>
                    {/* {doc.sNo >= 15 && doc.youtubeUrl && extractYoutubeId(doc.youtubeUrl) && (
                      <Tr>
                        <Td colSpan="3">
                          <VideoContainer>
                            <iframe
                              width="100%"
                              height="315"
                              src={`https://www.youtube.com/embed/${extractYoutubeId(doc.youtubeUrl)}`}
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                              title={`YouTube video for ${doc.name}`}
                            />
                          </VideoContainer>
                        </Td>
                      </Tr>
                    )} */}
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
            <MobileCardContainer>
              {documents.map((doc) => (
                <React.Fragment key={doc.sNo}>
                  <MobileCard>
                    <MobileCardContent>
                      <div>
                        <strong>{doc.sNo}.</strong> {doc.name}
                      </div>
                      {doc.pdfApplicable !== false && (
                        doc.pdfUrl ? (
                          <DownloadButton onClick={() => handleDocumentClick(doc.pdfUrl, doc.name)}>
                            PDF
                          </DownloadButton>
                        ) : (
                          <NotUploaded>PDF</NotUploaded>
                        )
                      )}
                      {doc.youtubeApplicable !== false && (
                        doc.youtubeUrl ? (
                          <VideoButton onClick={() => handleVideoClick(doc.youtubeUrl, doc.name)}>
                            Video
                          </VideoButton>
                        ) : (
                          <NotUploaded>Video</NotUploaded>
                        )
                      )}
                    </MobileCardContent>
                    {doc.youtubeApplicable !== false && doc.youtubeUrl && extractYoutubeId(doc.youtubeUrl) && (
                      <VideoContainer style={{ marginTop: '1rem' }}>
                        <iframe
                          width="100%"
                          height="200"
                          src={`https://www.youtube.com/embed/${extractYoutubeId(doc.youtubeUrl)}`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          title={`YouTube video for ${doc.name}`}
                        />
                      </VideoContainer>
                    )}
                  </MobileCard>
                </React.Fragment>
              ))}
            </MobileCardContainer>
          </>
        )}
      </Container>
      <Footer />
    </>
  );
};

export default CBSEDisclosures;







// import React, { useState, useEffect } from 'react';
// import { ref, get } from 'firebase/database';
// import { database } from '../firebase';
// import Header from './Header';
// import Footer from './Footer';
// import { toast } from 'react-toastify';
// import styled from 'styled-components';

// // Styled Components
// const Container = styled.div`
//   padding: 3rem;
//   max-width: 1100px;
//   margin: 2rem auto;
//   background: #ffffff;
//   border-radius: 20px;
//   box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//   position: relative;
//   overflow: hidden;
//   font-family: 'Poppins', sans-serif;

//   &:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     height: 6px;
//     background: linear-gradient(90deg, #3b82f6, #10b981);
//   }

//   @media (max-width: 768px) {
//     padding: 1.5rem;
//     margin: 1rem;
//   }
// `;

// const Title = styled.h1`
//   font-size: 2.5rem;
//   font-weight: 700;
//   color: #1e3a8a;
//   text-align: center;
//   margin-bottom: 2.5rem;
//   position: relative;

//   &:after {
//     content: '';
//     width: 80px;
//     height: 5px;
//     background: linear-gradient(90deg, #3b82f6, #10b981);
//     position: absolute;
//     bottom: -10px;
//     left: 50%;
//     transform: translateX(-50%);
//     border-radius: 3px;
//   }
// `;

// const LoadingContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   gap: 1.5rem;
//   padding: 3rem;
// `;

// const Spinner = styled.div`
//   width: 60px;
//   height: 60px;
//   border: 6px solid rgba(59, 130, 246, 0.2);
//   border-top-color: #3b82f6;
//   border-right-color: #10b981;
//   border-radius: 50%;
//   animation: spin 1s ease-in-out infinite;

//   @keyframes spin {
//     to {
//       transform: rotate(360deg);
//     }
//   }
// `;

// const Table = styled.table`
//   width: 100%;
//   border-collapse: separate;
//   border-spacing: 0;
//   background: white;
//   border-radius: 12px;
//   overflow: hidden;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

//   @media (max-width: 768px) {
//     display: none;
//   }
// `;

// const MobileCardContainer = styled.div`
//   display: none;
//   @media (max-width: 768px) {
//     display: flex;
//     flex-direction: column;
//     gap: 1rem;
//   }
// `;

// const MobileCard = styled.div`
//   background: white;
//   border-radius: 12px;
//   padding: 1rem;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
//   transition: transform 0.3s ease, box-shadow 0.3s ease;

//   &:hover {
//     transform: translateY(-5px);
//     box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
//   }
// `;

// const MobileCardContent = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// `;

// const Th = styled.th`
//   padding: 1.2rem;
//   text-align: left;
//   color: #1e293b;
//   font-weight: 600;
//   font-size: 1rem;
//   background: linear-gradient(180deg, #f8fafc, #f1f5f9);
//   border-bottom: 2px solid #e5e7eb;

//   &:first-child {
//     border-top-left-radius: 12px;
//   }
//   &:last-child {
//     border-top-right-radius: 12px;
//   }
// `;

// const Tr = styled.tr`
//   transition: all 0.3s ease;
//   opacity: 0;
//   animation: fadeIn 0.5s ease forwards;
//   animation-delay: ${props => props.index * 0.1}s;

//   &:hover {
//     background: ${props => props.clickable ? '#eff6ff' : 'white'};
//     transform: scale(1.01);
//   }

//   @keyframes fadeIn {
//     to {
//       opacity: 1;
//     }
//   }
// `;

// const Td = styled.td`
//   padding: 1.2rem;
//   border-bottom: 1px solid #f1f5f9;
//   font-size: 0.95rem;
//   color: #334155;

//   @media (max-width: 768px) {
//     padding: 0.8rem;
//     font-size: 0.9rem;
//   }
// `;

// const DownloadButton = styled.span`
//   color: white;
//   background: linear-gradient(90deg, #3b82f6, #2563eb);
//   font-weight: 500;
//   cursor: pointer;
//   padding: 0.6rem 1.2rem;
//   border-radius: 8px;
//   transition: all 0.3s ease;
//   display: inline-block;
//   position: relative;
//   overflow: hidden;

//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
//   }
// `;

// const NotUploaded = styled.span`
//   color: #9ca3af;
//   font-style: italic;
//   padding: 0.6rem 1.2rem;
// `;

// const VideosSection = styled.section`
//   margin-top: 3rem;
//   padding-top: 2rem;
//   border-top: 1px solid #e5e7eb;
// `;

// const VideoGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
//   gap: 1.5rem;
//   margin-top: 1.5rem;
// `;

// const VideoCard = styled.div`
//   background: white;
//   border-radius: 12px;
//   overflow: hidden;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
//   transition: transform 0.3s ease, box-shadow 0.3s ease;

//   &:hover {
//     transform: translateY(-5px);
//     box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
//   }
// `;

// const VideoPlayer = styled.div`
//   position: relative;
//   padding-bottom: 56.25%; /* 16:9 aspect ratio */
//   height: 0;
//   overflow: hidden;
//   background: #000;
// `;

// const VideoInfo = styled.div`
//   padding: 1rem;
// `;

// const VideoTitle = styled.h3`
//   margin: 0;
//   font-size: 1rem;
//   color: #1e293b;
// `;

// const SectionTitle = styled.h2`
//   font-size: 1.8rem;
//   color: #1e3a8a;
//   margin-bottom: 1.5rem;
//   position: relative;
//   padding-bottom: 0.5rem;

//   &:after {
//     content: '';
//     position: absolute;
//     bottom: 0;
//     left: 0;
//     width: 60px;
//     height: 3px;
//     background: linear-gradient(90deg, #3b82f6, #10b981);
//     border-radius: 3px;
//   }
// `;

// const CBSEDisclosures = () => {
//   const [documents, setDocuments] = useState([
//     { sNo: 1, name: 'TRUST REGISTRATION', pdfUrl: null, youtubeUrl: null },
//     { sNo: 2, name: 'NOC', pdfUrl: null, youtubeUrl: null },
//     { sNo: 3, name: 'RECOGNITION CERTIFICATE', pdfUrl: null, youtubeUrl: null },
//     { sNo: 4, name: 'BUILDING SAFETY CERTIFICATE', pdfUrl: null, youtubeUrl: null },
//     { sNo: 5, name: 'FIRE SAFETY CERTIFICATE', pdfUrl: null, youtubeUrl: null },
//     { sNo: 6, name: 'WATER HEALTH & SANITARY CERTIFICATE', pdfUrl: null, youtubeUrl: null },
//     { sNo: 7, name: 'FEE STRUCTURE OF THE SCHOOL', pdfUrl: null, youtubeUrl: null },
//     { sNo: 8, name: 'ANNUAL ACADEMIC CALENDAR', pdfUrl: null, youtubeUrl: null },
//     { sNo: 9, name: 'SMC', pdfUrl: null, youtubeUrl: null },
//     { sNo: 10, name: 'PTA', pdfUrl: null, youtubeUrl: null },
//     { sNo: 11, name: 'RTE', pdfUrl: null, youtubeUrl: null },
//     { sNo: 12, name: 'TEACHING STAFF', pdfUrl: null, youtubeUrl: null },
//     { sNo: 13, name: 'CERTIFICATE OF LAND', pdfUrl: null, youtubeUrl: null },
//     { sNo: 14, name: 'SELF CERTIFICATE', pdfUrl: null, youtubeUrl: null },
//     { sNo: 15, name: 'LIBRARY', pdfUrl: null, youtubeUrl: null },
//     { sNo: 16, name: 'SCHOOL COMPOUND', pdfUrl: null, youtubeUrl: null },
//     { sNo: 17, name: 'CSWN – BOYS & GIRLS', pdfUrl: null, youtubeUrl: null },
//     { sNo: 18, name: 'SCIENCE LAB', pdfUrl: null, youtubeUrl: null },
//     { sNo: 19, name: 'SCHOOL ENTRY VIEW & CLASS ROOMS', pdfUrl: null, youtubeUrl: null },
//     { sNo: 20, name: 'COMPUTER LAB', pdfUrl: null, youtubeUrl: null },
//   ]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
        
//         const docsRef = ref(database, 'school/documents');
//         const docsSnapshot = await get(docsRef);
        
//         if (docsSnapshot.exists()) {
//           const storedDocs = docsSnapshot.val();
//           setDocuments(prevDocs =>
//             prevDocs.map(doc => ({
//               ...doc,
//               pdfUrl: storedDocs[doc.sNo]?.pdfUrl || null,
//               youtubeUrl: storedDocs[doc.sNo]?.youtubeUrl || null,
//             }))
//           );
//         }

//         toast.success('Data loaded successfully', {
//           position: "top-center",
//           autoClose: 2000,
//         });
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         toast.error('Failed to load data. Please try again.', {
//           position: "top-center",
//           autoClose: 3000,
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   const handleDocumentClick = (pdfUrl, docName) => {
//     if (pdfUrl) {
//       const link = document.createElement('a');
//       link.href = pdfUrl;
//       link.download = `${docName.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       toast.success(`Downloading ${docName}`, {
//         position: "top-center",
//         autoClose: 2000,
//       });
//     } else {
//       toast.info('This document is not available yet', {
//         position: "top-center",
//         autoClose: 3000,
//       });
//     }
//   };

//   const getYouTubeId = (url) => {
//     const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
//     const match = url?.match(regExp);
//     return (match && match[2].length === 11) ? match[2] : null;
//   };

//   const renderSkeletonRows = () => {
//     return Array(5).fill().map((_, index) => (
//       <tr key={index}>
//         <Td><div style={{ height: '24px', background: '#e5e7eb', borderRadius: '6px' }}></div></Td>
//         <Td><div style={{ height: '24px', background: '#e5e7eb', borderRadius: '6px' }}></div></Td>
//         <Td><div style={{ height: '24px', background: '#e5e7eb', borderRadius: '6px' }}></div></Td>
//       </tr>
//     ));
//   };

//   const renderSkeletonCards = () => {
//     return Array(5).fill().map((_, index) => (
//       <div key={index} style={{ 
//         background: '#f8fafc', 
//         borderRadius: '12px', 
//         height: '250px',
//         animation: 'shimmer 2s infinite linear',
//         background: 'linear-gradient(90deg, #f8fafc 25%, #e5e7eb 50%, #f8fafc 75%)',
//         backgroundSize: '200px 100%'
//       }} />
//     ));
//   };

//   // Filter documents to only show videos for 15-20
//   const videoDocuments = documents.filter(doc => doc.sNo >= 15 && doc.sNo <= 20);

//   return (
//     <>
//       <Header />
//       <Container>
//         <Title>CBSE Mandatory Disclosures</Title>
        
//         {loading ? (
//           <LoadingContainer>
//             <Spinner />
//             <p>Loading documents...</p>
//           </LoadingContainer>
//         ) : (
//           <>
//             {/* PDF Documents Table */}
//             <Table>
//               <thead>
//                 <tr>
//                   <Th>S.No</Th>
//                   <Th>Document/Information</Th>
//                   <Th>Action</Th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {documents.map((doc, index) => (
//                   <Tr
//                     key={doc.sNo}
//                     clickable={!!doc.pdfUrl}
//                     index={index}
//                     onClick={() => handleDocumentClick(doc.pdfUrl, doc.name)}
//                   >
//                     <Td>{doc.sNo}</Td>
//                     <Td>{doc.name}</Td>
//                     <Td>
//                       {doc.pdfUrl ? (
//                         <DownloadButton>Download PDF</DownloadButton>
//                       ) : (
//                         <NotUploaded>Not Uploaded</NotUploaded>
//                       )}
//                     </Td>
//                   </Tr>
//                 ))}
//               </tbody>
//             </Table>
            
//             <MobileCardContainer>
//               {documents.map((doc) => (
//                 <MobileCard
//                   key={doc.sNo}
//                   onClick={() => handleDocumentClick(doc.pdfUrl, doc.name)}
//                 >
//                   <MobileCardContent>
//                     <div>
//                       <strong>{doc.sNo}.</strong> {doc.name}
//                     </div>
//                     {doc.pdfUrl ? (
//                       <DownloadButton>Download</DownloadButton>
//                     ) : (
//                       <NotUploaded>Not Uploaded</NotUploaded>
//                     )}
//                   </MobileCardContent>
//                 </MobileCard>
//               ))}
//             </MobileCardContainer>

//             {/* YouTube Videos Section (only for documents 15-20) */}
//             <VideosSection>
//               <SectionTitle>School Videos (Documents 15-20)</SectionTitle>
              
//               {loading ? (
//                 <VideoGrid>
//                   {renderSkeletonCards()}
//                 </VideoGrid>
//               ) : (
//                 <VideoGrid>
//                   {videoDocuments.map(doc => {
//                     const videoId = getYouTubeId(doc.youtubeUrl);
//                     return doc.youtubeUrl ? (
//                       <VideoCard key={doc.sNo}>
//                         <VideoPlayer>
//                           {videoId && (
//                             <iframe
//                               width="100%"
//                               height="100%"
//                               src={`https://www.youtube.com/embed/${videoId}`}
//                               frameBorder="0"
//                               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                               allowFullScreen
//                               style={{ position: 'absolute', top: 0, left: 0 }}
//                               title={doc.name}
//                             />
//                           )}
//                         </VideoPlayer>
//                         <VideoInfo>
//                           <VideoTitle>{doc.name}</VideoTitle>
//                         </VideoInfo>
//                       </VideoCard>
//                     ) : null;
//                   }).filter(Boolean)}
//                 </VideoGrid>
//               )}
//               {!loading && videoDocuments.every(doc => !doc.youtubeUrl) && (
//                 <p style={{ color: '#64748b', textAlign: 'center' }}>
//                   No videos available for documents 15-20. Check back later.
//                 </p>
//               )}
//             </VideosSection>
//           </>
//         )}
//       </Container>
//       <Footer/>
//     </>
//   );
// };

// export default CBSEDisclosures;









